import { useEffect, useState } from "react";
import { PublicTransportImportType } from "../../../../constant/PublicTransportImportType";
import PublicTransportService from "../../../../services/PublicTransportService";
import { ComparisonReport as ImportComparisonReport } from "../../../../types/LayerAdmin/ComparisonReport";
import { TableColumn } from "../../../../types/Table/TableColumns";
import SortableTable from "../../../Table/SortableTable";
import LoadingSpinner from "../../../Loading/LoadingSpinner";
import styled from "styled-components";
import { FormSelect } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface ComparisonReportProps {
  service: PublicTransportService;
}

const TableTitle = styled.p`
  font-size: 1.2rem;
  border-bottom: 1px solid #ccc;
  padding-bottom: 0.2rem;
  margin-bottom: 0.5rem;
`;

const options = [
  {
    value: PublicTransportImportType.AtocCif,
    label: "ATOC",
  },
  {
    value: PublicTransportImportType.Traveline,
    label: "Traveline",
  },
  {
    value: PublicTransportImportType.TransitLand,
    label: "Transitland",
  },
];

const ComparisonReport = ({ service }: ComparisonReportProps) => {
  const [comparisonReport, setComparisonReport] =
    useState<ImportComparisonReport>();

  const [type, setType] = useState<PublicTransportImportType>(
    PublicTransportImportType.AtocCif,
  );

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    service
      .ComparePublicTransportImporters(type)
      .then((cr) => {
        setComparisonReport(cr);
      })
      .catch(() => {

      })
      .finally(() => {
        setLoading(false);
      });
  }, [type]);

  const operatorCols: TableColumn[] = [
    {
      displayName: "Old Count",
      field: "operatorsOldCount",
      sortable: false,
    },
    {
      displayName: "New Count",
      field: "operatorsNewCount",
      sortable: false,
    },
    {
      displayName: "Difference Count",
      field: "operatorsDifferenceCount",
      sortable: false,
    },
    {
      displayName: "Difference Percentage",
      field: "operatorsDifferencePercentage",
      sortable: false,
    },
  ];

  const routesCols: TableColumn[] = [
    {
      displayName: "Old Count",
      field: "routesOldCount",
      sortable: false,
    },
    {
      displayName: "New Count",
      field: "routesNewCount",
      sortable: false,
    },
    {
      displayName: "Difference Count",
      field: "routesDifferenceCount",
      sortable: false,
    },
    {
      displayName: "Difference Percentage",
      field: "routesDifferencePercentage",
      sortable: false,
    },
  ];

  const tripsCols: TableColumn[] = [
    {
      displayName: "Old Count",
      field: "tripsOldCount",
      sortable: false,
    },
    {
      displayName: "New Count",
      field: "tripsNewCount",
      sortable: false,
    },
    {
      displayName: "Difference Count",
      field: "tripsDifferenceCount",
      sortable: false,
    },
    {
      displayName: "Difference Percentage",
      field: "tripsDifferencePercentage",
      sortable: false,
    },
  ];

  return (
    <div>
      <FormSelect
        className="w-25 mb-3"
        value={type}
        onChange={(e: React.ChangeEvent<any>) => setType(e.target.value)}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </FormSelect>
      {comparisonReport && (<>
        <TableTitle>Operators</TableTitle>
        <SortableTable
          height="auto"
          columns={operatorCols}
          data={[comparisonReport]}
          loading={loading}
        />
        <TableTitle>Routes</TableTitle>
        <SortableTable
          height="auto"
          columns={routesCols}
          data={[comparisonReport]}
          loading={loading}
        />
        <TableTitle>Trips</TableTitle>
        <SortableTable
          height="auto"
          columns={tripsCols}
          data={[comparisonReport]}
          loading={loading}
        /></>)}
        {loading && <LoadingSpinner />}
      {!comparisonReport && !loading && (
        <p className="text-center">No comparison report available for this type.</p>
      )}
    </div>
  )
};

export default ComparisonReport;
